import React from 'react';

const MyClassroomsSkeleton = () => {
	return (
		<>
			<div className={'my-classrooms-box'}>
				<div className={'my-classrooms-title-box skeleton'}>
					<h3 className={''}></h3>
				</div>
				<div className={'my-classrooms-slider-box skeleton'}></div>
			</div>
			<div className={'my-classrooms-box'}>
				<div className={'my-classrooms-title-box skeleton'}>
					<h3 className={''}></h3>
				</div>
				<div className={'my-classrooms-slider-box skeleton'}></div>
			</div>
			<div className={'my-classrooms-box'}>
				<div className={'my-classrooms-title-box skeleton'}>
					<h3 className={''}></h3>
				</div>
				<div className={'my-classrooms-slider-box skeleton'}></div>
			</div>
		</>
	);
};

export default MyClassroomsSkeleton;
